/* eslint-disable react/prop-types */
import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Skeleton from "@mui/material/Skeleton";
import Gallery from "./Gallery";
import "./Style/styles.css";
import Image from "./Image";

// eslint-disable-next-line react/prop-types
function PropertiesView({ properties, load }) {
  return (
    <>
      {load ? (
        <>
          <Tabs>
            <TabList>
              <Tab>
                <MKTypography variant="body2" color="text" pl={1}>
                  <span className="material-icons-outlined">reorder</span>
                  <br />
                  LISTA
                </MKTypography>
              </Tab>
              <Tab>
                <MKTypography variant="body2" color="text" pl={1}>
                  <span className="material-icons-outlined">view_quilt</span>
                  <br />
                  GALERIA
                </MKTypography>
              </Tab>
            </TabList>
            <TabPanel>
              <br />
              <Grid
                container
                spacing={2}
                sx={{ backgroundColor: "#FFF" }}
                width="105%"
                height="100%"
              >
                <Container sx={{ backgroundColor: "#FFF", border: "none" }}>
                  <Grid container spacing={1}>
                    <Table sx={{ minWidth: "50%", maxWidth: "100%" }} aria-label="simple table">
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ borderBottom: "none" }}>
                            <div className="celda">
                              <div className="images">
                                <Skeleton
                                  variant="rectangular"
                                  animation="wave"
                                  className="flag"
                                  height={150}
                                />
                              </div>
                              <div className="title-container">
                                <div>
                                  <div>
                                    <MKTypography variant="body2" color="text">
                                      <Skeleton style={{ width: "70%", marginLeft: "200px" }} />
                                    </MKTypography>
                                    <div className="stats2">
                                      <div>
                                        <div className="sub-title">
                                          <MKTypography variant="body2" color="text">
                                            &nbsp;
                                            <Skeleton
                                              variant="rectangular"
                                              animation="wave"
                                              height={40}
                                            />
                                          </MKTypography>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="sub-title">
                                          <MKTypography variant="body2" color="text">
                                            &nbsp;
                                            <Skeleton
                                              variant="rectangular"
                                              animation="wave"
                                              height={40}
                                            />
                                          </MKTypography>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="sub-title">
                                          <MKTypography variant="body2" color="text">
                                            &nbsp;
                                            <Skeleton
                                              variant="rectangular"
                                              animation="wave"
                                              height={40}
                                            />
                                          </MKTypography>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>
                </Container>
              </Grid>
            </TabPanel>
          </Tabs>
        </>
      ) : (
        <>
          <Tabs>
            <TabList>
              <Tab>
                <MKTypography variant="body2" color="text" pl={1}>
                  <span className="material-icons-outlined">reorder</span>
                  <br />
                  LISTA
                </MKTypography>
              </Tab>
              <Tab>
                <MKTypography variant="body2" color="text" pl={1}>
                  <span className="material-icons-outlined">view_quilt</span>
                  <br />
                  GALERIA
                </MKTypography>
              </Tab>
            </TabList>
            <TabPanel>
              <br />
              <Grid
                container
                spacing={2}
                sx={{ backgroundColor: "#FFF" }}
                width="105%"
                height="100%"
              >
                {properties?.map((item) => (
                  <>
                    <Container sx={{ backgroundColor: "#FFF", border: "none" }} key={item.name}>
                      <Grid container spacing={1}>
                        <Table sx={{ minWidth: "50%", maxWidth: "100%" }} aria-label="simple table">
                          <TableBody>
                            <TableRow>
                              <TableCell sx={{ borderBottom: "none" }}>
                                <div className="celda">
                                  <div className="images">
                                    <a href={`/details/${item.id}`}>
                                      <Image imageUrl={item.imagesproperty_set} />
                                    </a>
                                  </div>
                                  <div className="title-container">
                                    <a href={`/details/${item.id}`}>
                                      <MKTypography variant="h3">{item.name}</MKTypography>
                                    </a>
                                    <div>
                                      <div>
                                        <MKTypography variant="body2" color="text">
                                          {item.street}, &nbsp;{item.suburb.name} <br />
                                        </MKTypography>
                                        <div className="stats2">
                                          <div>
                                            <div className="sub-title">
                                              <MKTypography variant="body2" color="text">
                                                <span className="material-icons-outlined">
                                                  select_all
                                                </span>
                                                &nbsp;{item.area}
                                                <sup>2</sup>
                                              </MKTypography>
                                              <MKTypography variant="button">Área</MKTypography>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="sub-title">
                                              <MKTypography variant="body2" color="text">
                                                <span className="material-icons-outlined">
                                                  location_searching
                                                </span>
                                                &nbsp;{item.zone?.name}
                                              </MKTypography>
                                              <MKTypography variant="button">Zona</MKTypography>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="sub-title">
                                              <MKTypography variant="body2" color="text">
                                                <span className="material-icons-outlined">
                                                  grid_view
                                                </span>
                                                &nbsp;{item.block?.name}
                                              </MKTypography>
                                              <MKTypography variant="button">Manzana</MKTypography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Container>
                  </>
                ))}
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid container>
                {properties?.map((item) => (
                  <>
                    <Grid
                      item
                      container
                      direction="column"
                      xs={8}
                      sm={8}
                      lg={6}
                      sx={{ padding: 1, height: "auto" }}
                    >
                      <div className="card">
                        <Box justifyContent="center" alignItems="center" margin="4px">
                          <Gallery imageUrl={item.imagesproperty_set} />
                        </Box>
                        <MKTypography variant="h3">&nbsp;{item.name}</MKTypography>
                        <MKTypography variant="body2" color="text">
                          <span className="material-icons-outlined">location_on</span>
                          {item.street}, &nbsp;
                          {item.suburb.name}
                        </MKTypography>
                        <Grid container>
                          <Grid item sm={6} lg={11} style={{ padding: "15px" }}>
                            <Box display="flex" justifyContent="flex-end">
                              <a href={`/details/${item.id}`}>
                                <MKTypography variant="h5" color="#344767">
                                  Más información
                                  <span className="material-icons-outlined">arrow_forward</span>
                                </MKTypography>
                              </a>
                            </Box>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </>
                ))}
              </Grid>
            </TabPanel>
          </Tabs>
          <br />
        </>
      )}
    </>
  );
}

export default PropertiesView;
